export const getCommonStyles = (isDarkTheme: boolean) => ({
  separator: {
    border: 'none',
    height: '1px',
    backgroundColor: isDarkTheme ? '#555' : '#ccc',
    margin: '0 0 20px 0'
  },
  
  button: {
    padding: '12px 24px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer'
  },
  
  input: {
    padding: '8px',
    border: `1px solid ${isDarkTheme ? '#555' : '#ccc'}`,
    borderRadius: '4px',
    backgroundColor: isDarkTheme ? '#333' : '#fff',
    color: isDarkTheme ? '#fff' : '#000'
  },
  
  container: {
    marginBottom: '20px',
    padding: '15px',
    border: `1px solid ${isDarkTheme ? '#555' : '#ccc'}`,
    borderRadius: '4px',
    backgroundColor: isDarkTheme ? '#2a2a2a' : '#fff'
  }
});